<template>
  <div id="app">
        <auto-logout></auto-logout>
    <!-- <div id="nav">
      <router-link to="/" exact>Home</router-link> |
      <router-link to="/about" exact>About</router-link>
    </div>
    <h2>asda</h2> -->
    <router-view/>
     <vue-ins-progress-bar></vue-ins-progress-bar>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'App',
  mounted () {
 
    const plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      "https://widget.manychat.com/937710489660769.js"
    );
    plugin.async = true;
    document.head.appendChild(plugin);
    this.$insProgress.finish()
  },
  created () {
    
    
    this.$insProgress.start()

    this.$router.beforeEach((to, from, next) => {
      this.$insProgress.start()
      next()
      
    })

    this.$router.afterEach((to, from) => {
      this.$insProgress.finish()
    })
  }
}
</script>

<style>

html,body{
  box-sizing: border-box;
  margin:0;
  padding:0;
}
#app{
  overflow: hidden;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
*::-webkit-scrollbar {
    width: 7px;
}

*::-webkit-scrollbar-thumb {
    background: #1660ab;
}
*::-webkit-scrollbar-track {
    background: #fff;
}
.custom-checkbox .custom-control-label::before {
    border-radius: 50%!important;
}
.flex{
  display: flex;
}
.align-center{
  align-items: center;
}
.j-center{
  justify-content: left;
}
.no-space{
  padding:0;
  margin:0;
}
.block{
  display: block!important;
}
.column{
  flex-direction: column;
}

</style>
